import * as React from 'react'
import { Box, Button } from '@mui/material'

export function Pagination({
  total,
  batchSize = 100,
  onRangeChange,
}: {
  total: number
  batchSize?: number
  onRangeChange: (r: { start: number; end: number }) => void
}) {
  const [currentIndex, setCurrentIndex] = React.useState(0)

  const getEnd = () => {
    return Math.min(currentIndex + batchSize, total)
  }

  React.useEffect(() => {
    setCurrentIndex(0)
  }, [total])

  React.useEffect(() => {
    onRangeChange({
      start: currentIndex,
      end: getEnd(),
    })
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [currentIndex, total, batchSize])

  const goNext = () => {
    if (total < currentIndex + batchSize) return
    setCurrentIndex(currentIndex + batchSize)
  }

  const goPrev = () => {
    const prev = Math.max(0, currentIndex - batchSize)
    setCurrentIndex(prev)
  }
  return (
    <Box>
      <Button onClick={goPrev}>{'<'}</Button>
      {`${currentIndex} to ${getEnd()}`}
      <Button onClick={goNext}>{'>'}</Button>
    </Box>
  )
}
